export const ru = {
    'button-text': 'Ставка'
};
